<script lang="ts">
	import { Icon, Label, LabelV2, type LabelV2PropsTypes } from '@Shelly/shelly-design-system/index';
	/** Global / main radar zone — same convention as RadarDrawer and device_data_helpers */
	const MAIN_PRESENCE_ZONE_KEY = 'presencezone:200';

	export let useV2Components = false;
	export let labelV2Props: Partial<LabelV2PropsTypes> = {};
	export let status: any;

	$: mainZone = status?.[MAIN_PRESENCE_ZONE_KEY];
	$: peopleCount = mainZone?.num_objects ?? 0;
	$: hasPresence = mainZone?.value === true || peopleCount > 0;

	function presenceLabel(count: number): string {
		if (count <= 0) return 'No objects';
		if (count === 1) return '1 object';
		return `${count} objects`;
	}

	$: displayInfo = {
		count: peopleCount,
		hasPresence,
		label: presenceLabel(peopleCount),
	};
</script>

{#if useV2Components}
	<LabelV2
		iconColor={displayInfo.hasPresence ? 'green' : 'red'}
		icon="fal {displayInfo.hasPresence ? 'fa-sensor-on' : 'fa-sensor'}"
		value={displayInfo.label}
		{...labelV2Props}
	/>
{:else}
	<Label
		iconColor={displayInfo.hasPresence ? 'green' : 'red'}
		icon="fas {displayInfo.hasPresence ? 'fa-sensor-on' : 'fa-sensor'}"
		value={displayInfo.label}
		size="m"><Icon icon="fal fa-gear" /></Label
	>
{/if}

<style scoped></style>
